// TODO: rename to using 'sm', 'md', 'lg', and 'xl' in 5.0

export const breakpoints = {
  s: {
    max: 600
  },
  m: {
    min: 601,
    max: 970
  },
  l: {
    min: 971,
    max: 1280
  },
  xl: {
    min: 1281
  }
};